import React from "react";
import CheckIcon from "../../Assets/check-icon.svg";
export default function FindNewCustomers() {
  const items = [
    "Dream Projects",
    "Leading Brands",
    "Big Budgets",
    "Consistent Production",
    "Direct to Brand",
    "Agencies",
  ];

  return (
    <section className="px-6 py-2 lg:py-12 lg:w-[50%] mx-auto lg:text-left text-center mt-5 lg:mt-0">
      {/* Heading */}
      <h2 className="text-[2rem] lg:text-[3rem] font-bold leading-tight">
        <span className="text-brand-green">Find New</span>{" "}
        <span className="block text-black">Amazing Customers!</span>
      </h2>

      {/* Subtext */}
      <p className="mt-3 text-base text-gray-700">
        We book meetings for you with:
      </p>

      {/* List */}
      <div className="grid grid-cols-2 sm:grid-cols-2 gap-5 lg:gap-y-6 mt-6">
        {items.map((item, i) => (
          <div key={i} className="flex  items-start gap-3 ">
            <img src={CheckIcon} className="w-4 h-4 lg:w-7  lg:h-7" alt="Check mark" />
            <span className="font-semibold lg:w-[40%] -mt-.5 text-sm lg:text-[1.2rem]">
              {item}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
